var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "my-task"
    },
    [
      _c(
        "div",
        { staticClass: "task-top" },
        [
          _c("search-form", {
            attrs: {
              "form-data": _vm.todoFormData,
              "btn-type": "search, reset"
            },
            on: {
              changeSelect: _vm.changeSelect,
              searchForm: _vm.searchForm,
              resetForm: _vm.resetForm
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "task-stay",
          class: { "task-card": _vm.switchType === "列表切换" }
        },
        [
          _vm.switchType === "列表切换" && !_vm.todoList.length
            ? [
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("no-data", {
                      attrs: { height: "400px", width: "400px" }
                    })
                  ],
                  1
                )
              ]
            : _vm.switchType === "列表切换" && _vm.todoList.length
            ? _vm._l(_vm.todoList, function(item, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass:
                      "task-stay-item animate__animated animate__fadeInUp",
                    on: {
                      click: function($event) {
                        return _vm.openTask(item)
                      }
                    }
                  },
                  [
                    item.todoStatus == "PENDING"
                      ? _c("div", [
                          _c("div", { staticClass: "task-stay-title line" }, [
                            _vm._v(_vm._s(item.todoTitle))
                          ]),
                          _c("div", { staticClass: "task-stay-name" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  item.createdName == null
                                    ? item.createdBy
                                    : item.createdName + "/" + item.createdBy
                                ) +
                                " 发起 "
                            )
                          ]),
                          _c("div", { staticClass: "task-stay-bottom" }, [
                            _c("div", { staticClass: "stay-bot-left" }, [
                              _vm._v(_vm._s(item.createdTime))
                            ]),
                            _vm._m(0, true)
                          ])
                        ])
                      : _c("div", [
                          _c("div", { staticClass: "task-stay-title line" }, [
                            _vm._v(_vm._s(item.todoTitle))
                          ]),
                          _c("div", { staticClass: "task-stay-name" }, [
                            _vm._v(_vm._s(item.userId) + " 处理")
                          ]),
                          _c("div", { staticClass: "task-stay-bottom" }, [
                            _c("div", { staticClass: "stay-bot-left" }, [
                              _vm._v(_vm._s(item.createdTime))
                            ]),
                            _vm._m(1, true)
                          ])
                        ])
                  ]
                )
              })
            : [
                _c(
                  "el-table",
                  {
                    ref: "multipleTable",
                    staticClass: "expand-table",
                    staticStyle: { width: "100%" },
                    attrs: {
                      border: "",
                      data: _vm.todoList,
                      "tooltip-effect": "dark"
                    }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "systemId",
                        label: "系统名称",
                        "min-width": "80"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: { effect: "dark", placement: "top" }
                                },
                                [
                                  _c("div", {
                                    attrs: { slot: "content" },
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.ToBreak(
                                          _vm.getsystemname(scope.row.systemId)
                                        )
                                      )
                                    },
                                    slot: "content"
                                  }),
                                  _c("div", { staticClass: "line" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getsystemname(scope.row.systemId)
                                      )
                                    )
                                  ])
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "todoTitle",
                        label: "任务名称",
                        "min-width": "80",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "todoDescription",
                        label: "任务描述",
                        "min-width": "80",
                        "show-overflow-tooltip": ""
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "todoStatus",
                        label: "任务状态",
                        "min-width": "80"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("div", { staticClass: "task-state" }, [
                                _c("i", {
                                  staticClass: "task-state-circular",
                                  style: {
                                    background:
                                      scope.row.todoStatus === "COMPLETE"
                                        ? "#52C41A"
                                        : "#FF4E49"
                                  }
                                }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("todoStatusFilter")(
                                        scope.row.todoStatus
                                      )
                                    )
                                  )
                                ])
                              ])
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createdTime",
                        label: "任务创建时间",
                        "min-width": "80"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "createdName",
                        label: "任务创建人",
                        "min-width": "80"
                      }
                    }),
                    this.todoFormData[2].selectedArr.indexOf(
                      "COMPLETE" || "CLOSE"
                    ) > -1
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "updatedTime",
                            label: "任务完成时间",
                            "min-width": "80"
                          }
                        })
                      : _vm._e(),
                    this.todoFormData[2].selectedArr.indexOf(
                      "COMPLETE" || "CLOSE"
                    ) > -1
                      ? _c("el-table-column", {
                          attrs: {
                            prop: "userId",
                            label: "任务处理人",
                            "min-width": "80",
                            "show-overflow-tooltip": ""
                          }
                        })
                      : _vm._e(),
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "80" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "op-edit",
                                  staticStyle: {
                                    cursor: "pointer",
                                    color: "var(--mainColor)"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.openTask(scope.row)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.todoStatus == "PENDING"
                                          ? "处理"
                                          : "查看"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]
        ],
        2
      ),
      _c("div", { staticClass: "footer-page" }, [
        _c(
          "div",
          { staticClass: "footer-right" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.searchReq.pageNum,
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                total: _vm.total,
                "hide-on-single-page": false
              },
              on: {
                "size-change": _vm.onSizeChange,
                "current-change": _vm.onCurrentChange
              }
            })
          ],
          1
        )
      ]),
      _c("task-container", {
        ref: "TaskContainer",
        on: { searchForm: _vm.searchForm }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            title: _vm.todoTitle,
            visible: _vm.showDialog,
            top: "15vh",
            width: "570px",
            center: "",
            modal: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showDialog = $event
            }
          }
        },
        [
          _vm.showDialog
            ? _c("iframe", {
                ref: "iframe",
                staticClass: "task-container-iframe",
                staticStyle: {
                  width: "100%",
                  "min-height": "505px",
                  border: "none"
                },
                attrs: { name: "iframe", src: _vm.dialogUrl }
              })
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stay-bot-right" }, [
      _c("input", {
        staticClass: "btn btn-red",
        attrs: { type: "button", value: "处理" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stay-bot-right" }, [
      _c("input", {
        staticClass: "btn btn-red",
        attrs: { type: "button", value: "查看" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }